import { render, staticRenderFns } from "./TerrainModal.vue?vue&type=template&id=04d3ae54&scoped=true"
import script from "./TerrainModal.vue?vue&type=script&lang=js"
export * from "./TerrainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3ae54",
  null
  
)

export default component.exports